import type { SongSummary } from '@pipi/shared';
import { Cloud, Heart, ListPlus, Mic2, Play, WifiOff } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAppState } from '../state/app-state';
import { CoverArt } from './cover-art';
import { ProviderBadge } from './provider-badge';

export function SongCard({ song, index = 0 }: { song: SongSummary; index?: number }) {
  const navigate = useNavigate();
  const { addToQueue, setFavorite } = useAppState();
  return (
    <article
      className="song-card"
      data-tv-focusable
      tabIndex={0}
      style={{ '--stagger': `${Math.min(index, 10) * 24}ms` } as React.CSSProperties}
      onClick={() => navigate(`/play/${encodeURIComponent(song.id)}`)}
      aria-label={`${song.title}，${song.artist}`}
    >
      <div className="song-card__media">
        <CoverArt song={song} />
        <div className="song-card__badges">
          <ProviderBadge kind={song.providerKind} compact />
          {song.capabilities.scoring && <span className="capability-badge" title="支持评分"><Mic2 size={14} />评分</span>}
          {!song.capabilities.offline && song.media.kind === 'youtube' && <span className="capability-badge"><Cloud size={14} />联网</span>}
          {!song.capabilities.playable && <span className="capability-badge capability-badge--warning"><WifiOff size={14} />缺少媒体</span>}
        </div>
        <div className="song-card__actions">
          <button
            type="button"
            className="mini-action"
            aria-label={song.favorite ? '取消收藏' : '收藏'}
            onClick={(event) => {
              event.stopPropagation();
              void setFavorite(song, !song.favorite);
            }}
          >
            <Heart size={20} fill={song.favorite ? 'currentColor' : 'none'} />
          </button>
          <button
            type="button"
            className="mini-action"
            aria-label="加入点歌台"
            onClick={(event) => {
              event.stopPropagation();
              void addToQueue(song);
            }}
          >
            <ListPlus size={21} />
          </button>
        </div>
        <span className="song-card__play"><Play size={28} fill="currentColor" /></span>
      </div>
      <div className="song-card__copy">
        <h3>{song.title}</h3>
        <p>{song.artist}</p>
      </div>
    </article>
  );
}
